import { useState } from "react";
import Label from "../form/Label";
import Input from "../form/input/InputField";
import { EyeOff, Eye } from "lucide-react";

interface CampoSenhaProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
}

// Campo de senha com o olhinho de mostrar/esconder (mesmo ícone do login) —
// reaproveitado em TrocarSenhaCard e na tela de redefinir senha por link.
export default function CampoSenha({ label, value, onChange }: CampoSenhaProps) {
  const [mostrar, setMostrar] = useState(false);
  // Gerado do próprio label (sempre distinto entre os campos de uma mesma
  // tela) — casa Label com Input sem precisar de mais uma prop pra isso.
  const id = `senha-${label
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")}`;

  return (
    <div>
      <Label htmlFor={id}>{label}</Label>
      <div className="relative">
        <Input id={id} type={mostrar ? "text" : "password"} value={value} onChange={(e) => onChange(e.target.value)} />
        <button
          type="button"
          onClick={() => setMostrar(!mostrar)}
          aria-label={mostrar ? "Esconder senha" : "Mostrar senha"}
          className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500"
        >
          {mostrar ? (
            <Eye className="size-5 fill-gray-500 dark:fill-gray-400" />
          ) : (
            <EyeOff className="size-5 fill-gray-500 dark:fill-gray-400" />
          )}
        </button>
      </div>
    </div>
  );
}
